import React, { useEffect, useState, useRef } from "react";
import {
    Box,
    Button,
    TableFooter,
    TextField,
    TablePagination,
    Tooltip,
    Pagination,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    Backdrop,
    CircularProgress,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import axios from "axios";
import base_url from "../../constants.js";
import Cookies from "js-cookie";
import { RefreshSharp } from "@mui/icons-material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { format } from "date-fns";
import * as XLSX from "xlsx";
import useNotification from "../common/Notification.js";
import axiosInstance from "../../api/axiosInstance.js";
import { useNavigate } from "react-router-dom";
import { blue } from "@mui/material/colors";
// import TablePagination from "@mui/material";

// const base_url = "http://localhost:5000";

const getColor = (status) => {
    if (status === "PENDING") {
        return "#e6ba0b";
    } else if (status === "FAILED") {
        return "#e8120e";
    } else {
        return "#20bd6e";
    }
};

const options = ["FAILED", "COMPLETED", "PENDING", "READ", "BOUNCE"];

const EmailQueue = () => {
    const [data, setData] = useState([]);
    const [query, setQuery] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [pageNo, setPageNo] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [dateValue, setDateValue] = useState(null);
    const [statusOptions, setStatusOptions] = useState("");
    const [backdropOpen, setBackdropOpen] = useState(false);
    const [totalRows, setTotalRows] = useState(null);
        const [countData, setCountData] = useState({
            total_pending:  0,
    total_read:     0,
    total_completed :0,
    total_failed :   0
        })
    const [messageDialog, setMessageDialog] = useState({
        open: false,
        message: "",
    });
    const [exportDialog, setExportDialog] = useState({
        open: false,
        page: 0,
        totalPages: 0,
    });
    const exportAbortRef = useRef(null);

    const status = "PENDING";
    const showNotification = useNotification();
    const userId = Cookies.get("userId");
    const navigate = useNavigate();

    const handleOpenMessage = (message) => {
        setMessageDialog({ open: true, message: message || "No message" });
    };

    const handleCloseMessage = () => {
        setMessageDialog({ open: false, message: "" });
    };

    const handleCancelExport = () => {
        exportAbortRef.current?.abort();
        setExportDialog({ open: false, page: 0, totalPages: 0 });
        showNotification("Export cancelled.", "info");
    };

    const buildAndDownloadExcel = (rows) => {
        const sheetData = rows.map((row, index) => ({
            SNo: index + 1,
            ID: row.id,
            Email: row.email,
            Schedule_Date_Time: row.schedule_date_time,
            Status: row.status,
            Sender_Email: row.sender_email,
            Reply_Email: row.reply_email,
            Delivered_At: row.delivered_at,
            Opened_At: row.opened_at,
            // Message: row.message,
            // Error_Code: row.error_code,
            // Failure_Reason: row.failure_reason,
            Created_At: row.created_at,
        }));

        const workbook = XLSX.utils.book_new();
        const sheet = XLSX.utils.json_to_sheet(sheetData);

        if (sheetData.length > 0) {
            const headers = Object.keys(sheetData[0]);
            sheet["!cols"] = headers.map((key) => {
                const maxLen = Math.max(
                    key.length,
                    ...sheetData.map((row) => String(row[key] ?? "").length)
                );
                return { wch: Math.min(Math.max(maxLen + 2, 12), 50) };
            });
        }

        XLSX.utils.book_append_sheet(workbook, sheet, "Email Queue");
        XLSX.writeFile(
            workbook,
            `email_queue_export_${format(new Date(), "yyyy-MM-dd_HH-mm")}.xlsx`
        );
    };

    const handleExport = async () => {
        const controller = new AbortController();
        exportAbortRef.current = controller;

        const exportUserId = Cookies.get("userId");
        const hasFilters = Boolean(dateValue || statusOptions || query);
        const payload = hasFilters
            ? {
                  user_id: exportUserId,
                  date: dateValue,
                  status: statusOptions,
                  email: query,
              }
            : undefined;

        setExportDialog({ open: true, page: 1, totalPages: 0 });

        try {
            const allRows = [];
            let page = 1;
            let lastPage = 1;

            do {
                if (controller.signal.aborted) return;

                const res = await axiosInstance.post(
                    `${base_url}/emails/email-filter/v1?user_id=${exportUserId}&page=${page}`,
                    payload,
                    { signal: controller.signal }
                );
                const pageData = res.data?.data;
                const rows = pageData?.data || [];
                lastPage = pageData?.last_page || 1;

                allRows.push(...rows);
                setExportDialog({
                    open: true,
                    page,
                    totalPages: lastPage,
                });
                page += 1;
            } while (page <= lastPage);

            if (controller.signal.aborted) return;

            if (allRows.length === 0) {
                showNotification("No data to export!", "error");
                return;
            }

            buildAndDownloadExcel(allRows);
            showNotification(
                `Exported ${allRows.length} rows successfully!`,
                "success"
            );
        } catch (e) {
            if (
                controller.signal.aborted ||
                e.name === "CanceledError" ||
                e.code === "ERR_CANCELED"
            ) {
                return;
            }
            console.log("Export error: ", e);
            showNotification("Export failed!", "error");
        } finally {
            exportAbortRef.current = null;
            setExportDialog({ open: false, page: 0, totalPages: 0 });
        }
    };

    const fetchStatus = async (page) => {
        const userId = Cookies.get("userId");
        if (!page) page = 1;
        try {
            setBackdropOpen(true);

            // const res = await axios.get(`${base_url}/message/queue/status`);
            const res = await axiosInstance.post(
                `${base_url}/emails/email-filter/v1?user_id=${userId}&page=${page}`
            );
            console.log(res.data);
            setData(res.data.data.data);
            setFilteredData(res.data.data.data);
            setTotalPage(res.data.data.last_page);
            setCountData(res.data.summary);
            setTotalRows(res.data.data.total);
            showNotification("Latest data fetched!", "success");
        } catch (e) {
            console.log("Error: ", e);
            showNotification("Something went wrong while fetching!", "error");
        } finally {
            setBackdropOpen(false);
        }
    };
    useEffect(() => {
        fetchStatus();
    }, []);

    const handleSearch = () => {
        // yet to complete

        const newData = data.filter(
            (obj, idx) => obj.phone_number == query || obj.name === query
        );
        // if (newData.length == 0) {
        //     setFilteredData(() => {
        //         return data.filter((obj, idx) => obj.name == query);
        //     });
        // }
        setFilteredData(newData);
        setQuery("");
    };

    const handleQueryChange = (e) => {
        console.log(e.target);
        setQuery(e.target.value.trim());
    };

    const handleQuerySearch = async () => {
        const userId = Cookies.get("userId");
        setCurrentPage(1);
        setBackdropOpen(true);

        try {
            const payload = {
                user_id: userId,
                date: dateValue,
                status: statusOptions,
                email: query,
            };
            console.log("payload : ", payload);
            const res = await axiosInstance.post(
                `${base_url}/emails/email-filter/v1`,
                payload
            );
            console.log(res.data.data);
            setFilteredData(res.data.data.data);
            setTotalPage(res.data.data.last_page);
            setTotalRows(res.data.data.total);
            setCountData(res.data.summary);

            // setData(res.data.data);
            showNotification("Filtered Data.", "success");
        } catch (e) {
            console.log("Error: ", e);
            showNotification("No Data!", "error");
        } finally {
            setBackdropOpen(false);
        }
    };

    useEffect(() => {
        const getTableData = () => {
            if (query) {
                return filteredData;
            } else {
                return data;
            }
        };
        console.log(filteredData);
    }, [query]);

    const handleReset = () => {
        setFilteredData(data);
        setQuery("");
        setStatusOptions(null);
        setDateValue(null);
        // fetchStatus();
        setFilteredData(data);
    };

    const handlePageChange = (event, value) => {
        const page = value;
        setCurrentPage(value);
        console.log(value);
        fetchStatus(page);
    };

    console.log("Date value: ", dateValue);
    const handleDateChange = (newValue) => {
        // setDateValue(newValue);

        if (newValue instanceof Date && !isNaN(newValue)) {
            const formatted = format(newValue, "yyyy-MM-dd");
            setDateValue(formatted);
            console.log("Formatted date:", formatted);
        } else {
            console.warn("Invalid date:", newValue);
        }
    };
    // console.log("Date value: ", format(dateValue, "yyyy-MM-dd"));
    const handleStatusSelect = (e) => {
        setStatusOptions(e.target.value);
        console.log(e.target.value);
    };

    const handleEmailFetch = async (e, id, emailId) => {
        e.preventDefault(); // Prevent default anchor tag behavior
        // window.open(`/email/${userId}/${id}`, "_blank");
        const payload = {
            user_id: userId,
            id: id,
        };
        try {
            const res = await axiosInstance.post(
                "/emails/email-details",
                payload
            );
            console.log(res.data.data);
            if (res.data.data.length !== 0) {
                const email = res.data.data[0];
                navigate(`/email/${userId}/${id}`, {
                    state: {
                        email,
                        emailId,
                    },
                });
                return;
            }
            showNotification("Email Not Found!", "error");
        } catch (e) {
            console.error("Error: ", e);
            showNotification(`${e.message}`, "error");
        } finally {
            //
        }
    };

    return (
        <Box
            sx={{
                marginTop: "2rem",
                // bgcolor: "yellow",
            }}
        >
      <Typography variant='h6'  sx={{ mb: 4, mt: 3, color : 'primary.main', backgroundColor:blue[50], px:2, width: 'fit-content', py:1, borderRadius:2, fontWeight:'bold'}}>
        Email Queue
      </Typography>
            <Backdrop
                sx={(theme) => ({
                    color: "#fff",
                    zIndex: theme.zIndex.drawer + 1,
                })}
                open={backdropOpen}
                // onClick={handleClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 1,
                    mb: 2,
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        flexWrap: "nowrap",
                    }}
                >
                    <TextField
                        variant="outlined"
                        label={"Enter email"}
                        size="small"
                        id="outlined-basic"
                        value={query}
                        onChange={handleQueryChange}
                    />

                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            label="Select a date"
                            value={dateValue}
                            onChange={handleDateChange}
                            renderInput={(params) => (
                                <TextField {...params} size="small" />
                            )}
                        />
                    </LocalizationProvider>
                    <FormControl sx={{ width: "12rem" }}>
                        <InputLabel size="small">Select status</InputLabel>
                        <Select
                            value={statusOptions}
                            label={"Select an Option"}
                            onChange={handleStatusSelect}
                            size="small"
                        >
                            {options.map((option, i) => (
                                <MenuItem key={i} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Button
                        variant="contained"
                        onClick={handleQuerySearch}
                    >
                        Search
                    </Button>
                    <Button
                        variant="outlined"
                        onClick={handleReset}
                    >
                        RESET
                    </Button>
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        flexShrink: 0,
                    }}
                >
                    <Button
                        variant="outlined"
                        onClick={handleExport}
                        disabled={exportDialog.open}
                    >
                        Export
                    </Button>
                    <Tooltip title="Refresh Table">
                        <Button
                            variant="contained"
                            onClick={() => fetchStatus()}
                        >
                            <RefreshSharp />
                        </Button>
                    </Tooltip>
                </Box>
            </Box>

                        <Box
                            sx={{
                                height: "2rem",
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <Box sx={{ fontWeight: "500" }}>Total Rows: {totalRows}</Box>
                            <Box sx={{ fontWeight: "500" }}>Pending: {countData.total_pending} | Completed: {countData.total_completed} | Read: {countData.total_read} | Failed: {countData.total_failed} </Box>
            
                        </Box>

            <Paper sx={{ width: "100%", overflow: "hidden" }}>
                <TableContainer sx={{ maxHeight: "calc(100vh - 300px)" }}>
                    <Table
                        stickyHeader
                        component={Paper}
                        aria-label="sticky table"
                        sx={{
                            minWidth: 650,
                        }}
                    >
                        <TableHead
                            sx={{
                                bgcolor: "#1a2333",
                            }}
                        >
                            <TableRow sx={{ bgcolor: "#1a2333" }}>
                                <TableCell
                                    sx={{
                                        color: "#fcfdff",
                                        bgcolor: "#1a2333",
                                    }}
                                >
                                    ID
                                </TableCell>
                                {/* <TableCell
                                    sx={{
                                        color: "#fcfdff",
                                        bgcolor: "#1a2333",
                                    }}
                                >
                                    NAME
                                </TableCell> */}
                                <TableCell
                                    sx={{
                                        color: "#fcfdff",
                                        bgcolor: "#1a2333",
                                    }}
                                >
                                    EMAIL
                                </TableCell>

                                <TableCell
                                    sx={{
                                        color: "#fcfdff",
                                        bgcolor: "#1a2333",
                                    }}
                                >
                                    SCHEDULE DATE &nbsp;
                                </TableCell>
                                <TableCell
                                    sx={{
                                        color: "#fcfdff",
                                        bgcolor: "#1a2333",
                                    }}
                                >
                                    SCHEDULE TIME &nbsp;
                                </TableCell>
                                 <TableCell
                                    sx={{
                                        color: "#fcfdff",
                                        bgcolor: "#1a2333",
                                    }}
                                >
                                    UPDATED AT &nbsp;
                                </TableCell>
                                <TableCell
                                    sx={{
                                        color: "#fcfdff",
                                        bgcolor: "#1a2333",
                                    }}
                                >
                                    ACTION &nbsp;
                                </TableCell>
                                {/* <TableCell sx={{ color: "#fcfdff" }}>
                                    IMAGE &nbsp;
                                </TableCell> */}
                                <TableCell
                                    sx={{
                                        color: "#fcfdff",
                                        bgcolor: "#1a2333",
                                    }}
                                    align="center"
                                >
                                    STATUS&nbsp;
                                </TableCell>
                                <TableCell
                                    sx={{
                                        color: "#fcfdff",
                                        bgcolor: "#1a2333",
                                    }}
                                >
                                    MESSAGE &nbsp;
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredData.length > 0 &&
                                filteredData.map((row, idx) => (
                                    <TableRow
                                        key={row.id}
                                        // sx={{
                                        //     "&:last-child td, &:last-child th": {
                                        //         border: 0,
                                        //     },
                                        // }}
                                    >
                                        <TableCell component="th" scope="row">
                                            {row.id}
                                        </TableCell>
                                        {/* <TableCell>{row.name}</TableCell> */}

                                        <TableCell>{row.email}</TableCell>

                                        <TableCell>
                                            {row.schedule_date_time?.slice(
                                                0,
                                                10
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            {row.schedule_date_time?.slice(
                                                11,
                                                16
                                            )}
                                        </TableCell>
                                         <TableCell>
                                             {row.updated_at?.slice(0, 10) ||
                                                    "-"}
                                        </TableCell>
                                        <TableCell>
                                            {/* <a
                                                href={`/email/${userId}/${row.id}`}
                                                target="_blank"
                                            >
                                                View
                                            </a> */}

                                            <a
                                                href="/email-queue"
                                                onClick={(e) =>
                                                    handleEmailFetch(
                                                        e,
                                                        row.id,
                                                        row.email
                                                    )
                                                }
                                            >
                                                View
                                            </a>
                                        </TableCell>

                                        <TableCell
                                            align="center"
                                        >
                                            <Box
                                                sx={{
                                                    height: "auto",
                                                    width: "100px",
                                                    textAlign: "center",
                                                    display: "inline-block",
                                                    padding: "0.8rem",
                                                    color: "White",
                                                    borderRadius: 10,
                                                    bgcolor: getColor(
                                                        row.status
                                                    ),
                                                }}
                                            >
                                                {row.status}
                                            </Box>
                                        </TableCell>
                                        <TableCell>
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                onClick={() =>
                                                    handleOpenMessage(row.message)
                                                }
                                            >
                                                View Message
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                        {/* <TableFooter>
                            <TablePagination rowsPerPageOptions={[10, 50]} />
                        </TableFooter> */}
                    </Table>
                </TableContainer>
            </Paper>

            <Dialog
                open={messageDialog.open}
                onClose={handleCloseMessage}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        pr: 1,
                    }}
                >
                    Message
                    <IconButton
                        aria-label="close"
                        onClick={handleCloseMessage}
                        size="small"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Typography sx={{ whiteSpace: "pre-wrap" }}>
                        {messageDialog.message}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseMessage} variant="contained">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={exportDialog.open} disableEscapeKeyDown>
                <DialogContent
                    sx={{
                        display: "flex",
                        gap: 2,
                        alignItems: "center",
                        // minWidth: 280,
                        // py: 3,
                        // px: 3,
                        minWidth: 420,   // was 280 — increase this
                        minHeight: 120,  // optional, taller dialog
                        py: 4,
                        px: 4,
                    }}
                >
                    <CircularProgress size={28} />
                    <Typography>
                        {exportDialog.totalPages > 0
                            ? `Exporting… page ${exportDialog.page} of ${exportDialog.totalPages}`
                            : "Preparing export…"}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        color="error"
                        variant="outlined"
                        onClick={handleCancelExport}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            <Box
                sx={{
                    marginLeft: "auto",
                    width: "100%",
                    display: "flex",
                    justifyContent: "end",
                    mt: 2,
                }}
            >
                {filteredData.length > 0 && (
                    <Pagination
                        count={totalPage}
                        color="primary"
                        page={currentPage || 1}
                        onChange={handlePageChange}
                    />
                )}
            </Box>
        </Box>
    );
};

export default EmailQueue;
